module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightFilter3-24a2a510fc07d76b78420fe185ab0512.jpg";